export class ImgInvModel {
  imginvcode = '' ;
  imginvdate = '2022-01-01' ;
  imginv = '' ;
  imginvtype = '' ;
  imginvsite = '' ;
  imginvgrade = '' ;
  imginvn = '' ;
  imginvm = '' ;
  imginvcomm = '' ;
  imginvdate1 = '2022-01-01' ;
  rowid = 0 ;
  getfrom = '' ;
  visitdate = '2022-01-01' ;
  source = '' ;
  compcode = '' ;
  userid = '' ;
  modifieddate = '2022-01-01' ;

}
export class ImageTypeModel {
imageid = '' ;
imagename = '' ;
notes = '' ;
userid = '' ;
modifieddate = '2022-01-01' ;

}
